// extracted by mini-css-extract-plugin
module.exports = {"root":"Buttons_root__3voqL","title":"Buttons_title__w9a-F","section":"Buttons_section__YJXKC","buttons":"Buttons_buttons__3sRJW"};